export default "__VITE_ASSET__6f1b25a7__"